import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import XCircleblack from "../../IconComponents/XCircleblack";
import { postDataWithBody } from "../../../Services/Services";
import {
  resourceStatusClosed,
  resourceStatusInProgress,
} from "../../../Services/EndPoints";
import { toast } from "react-toastify";

const TaskModalWithCommentForResource = (props) => {
  const {
    title,
    titleValue,
    show,
    handleToggle,
    size,
    popupLabel,
    buttonLabel,
    taskData,
    getResourceList
  } = props;
  
  const [comment, setComment] = useState(""); // Track textarea value
  const [error, setError] = useState(""); // To store validation error message
  const [isLoading, setIsLoading] = useState(false);

  // Function to validate the comment length
  const validateCommentLength = () => {
    if (comment.length > 250) {
      setError("Maximum 250 characters are allowed.");
      return false;
    }
    if (comment.trim().length === 0) {
      setError("Comment is required.");
      return false;
    }
    setError(""); // Clear error message when valid
    return true;
  };

  // Handle comment change and validation
  const handleCommentChange = (e) => {
    setComment(e.target.value); // Update comment state
    if (error) validateCommentLength(); // Only validate if there's an existing error
  };

  const handleSubmit = async () => {
    if (!validateCommentLength()) {
      return; // Prevent submission if validation fails
    }

    setIsLoading(true);

    
    try {
      const currentDate = new Date().toISOString().split("T")[0];
      const payload = {
        id: taskData.id,
        action_message: comment,
        action_taken_date: currentDate,
        request_type: taskData.type // "ASSET" or "STAFF"
      };

      // Determine which API to call based on status transition
      let endpoint;
      if (taskData.currentStatus === "OPEN" && taskData.newStatus === "INPROGRESS") {
        endpoint = resourceStatusInProgress;
      } else if (taskData.currentStatus === "INPROGRESS" && taskData.newStatus === "COMPLETED") {
        endpoint = resourceStatusClosed;
      } else {
        throw new Error("Invalid status transition");
      }

      const res = await postDataWithBody(endpoint, payload, {});

      if (res && res.status === "success") {
        toast.success(res.msg || "Status updated successfully", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2000,
        });
        
        // Close the modal first
        handleToggle();
        
        // Wait for the toast to be visible, then reload the page
        setTimeout(() => {
          getResourceList();
        }, 250); // Wait slightly longer than the toast autoClose time
        
        // Alternative approach - if you want to refresh data without full page reload:
        // showSuccessMsg(); // Refresh the parent component
        // navigate("../resource-list", { replace: true });
      }
    } catch (error) {
      console.error("Error updating status:", error);
      // Error toast removed - only console logging remains
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal
      show={show}
      onHide={handleToggle}
      size={size}
      className="table__modal__popup"
      centered
    >
      <Modal.Header>
        <Modal.Title>
          {title}
          {titleValue}
        </Modal.Title>
        <XCircleblack
          className="cursor-pointer"
          onClick={handleToggle}
          width="1.5em"
          height="1.5em"
        />
      </Modal.Header>
      <Modal.Body>
        <div className="create__resource--popup">
          <div className="form-group">
            <label
              className="create__resource--label"
              htmlFor="tfld_config_value"
            >
              {popupLabel}
            </label>
            <div className="mb-2">
              <label className="label_txt mb-2">Description</label>
              <div className="mb-2">{taskData.description || "No description available"}</div>
            </div>
            <textarea
              type="text"
              placeholder="Write your action here"
              className="form-control"
              id="modal_comment_txt_area"
              value={comment}
              onChange={handleCommentChange}
              rows={4}
            />
            {error && <div className="text-danger mt-2">{error}</div>}
            <div className="text-end mt-1">
              <small>{comment.length}/250 characters</small>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          onClick={handleSubmit}
          type="button"
          className="btn btn-success"
          style={{ backgroundColor: "#1a7a73" }}
          disabled={isLoading || error || comment.trim().length === 0}
        >
          {isLoading ? "Processing..." : buttonLabel}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default TaskModalWithCommentForResource;